import $ from 'jquery';
import ajax from '../services/ajax';
// Template: redesign-slot-fastcompany/sites/all/static/public/templates/modules/collection_poll.hbs
// Styles: redesign-slot-fastcompany/sites/all/src/scss/modules/_collection_poll.scss

export default () => {
    function calculatePercentageOfDataSet(dataSet) {

        const sum = dataSet.reduce(function (prevValue, currValue) {
            return prevValue + currValue;
        });

        return dataSet.map(function (dataPoint) {
            return 100 * dataPoint / sum;
        });

    }
    function setUpCollectionPolls(index, el) {
        const $el = $(el);
        const dataModel = $el.attr('data-model');
        let json = false;
        try {
            if (dataModel) {
                json = JSON.parse(dataModel);
            }
        } catch (err) { // eslint-disable-line no-empty
            // TODO: log error
            // console.error(err);
        }

        if (json !== false) {
            const { id } = json;
            const $pollAnswer = $el.find('.js-poll-answer');
            const votedStorage = `FC_POLL_${id}}`;
            const previouslyVoted = window.localStorage.getItem(votedStorage);
            const handleVoted = function (data) {
                const poll = data.poll;
                const pollData = [poll.answer_one_count, poll.answer_two_count];
                const pollDataLookup = [{answer: poll.answer_one, data: poll.answer_one_count}, {answer: poll.answer_two, data: poll.answer_two_count}];
                const calculationsAray = calculatePercentageOfDataSet(pollData);
                const $inputs = $el.find('input');
                const $bars = $el.find('.bar');
                const $data = $el.find('.data');
                // debugger;
                $el.addClass('voted');
                $el.find(`#${previouslyVoted}`).attr('checked', 'checked');
                $inputs.attr('disabled', 'true');
                // let $question = $el.find('.poll-question');
                // if (poll.voted_view_title) {
                //     $question.text(poll.voted_view_title);
                // }
                let i = 0;
                for (i; i < calculationsAray.length; i++) {
                    $($data[i]).animate({width: calculationsAray[i].toString() + '%'}, 1000, 'linear');
                    $($bars[i]).find('label').text(Math.round(calculationsAray[i]).toString() + '% said ' + pollDataLookup[i].answer);
                }

            };
            // We need to do this bc fastly caches our pages!
            if (previouslyVoted && id) {
                return ajax(`/poll-api/v3/modules/collection-poll`, {
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        id
                    }
                }).then(handleVoted);
                    /*.catch(function handleVotedFail(err) {
                        // TODO: do something..
                    });*/
            }
            const handlePollVote = function () {
                // debugger;
                const answerId = this.id;
                const $this = $(this);
                const answer = $this.data('answer');
                window.localStorage.setItem(votedStorage, answerId);

                return ajax(`/poll-api/v3/modules/collection-poll`, {

                    method: 'POST',
                    dataType: 'json',
                    data: {
                        id,
                        answer
                    }
                }).then(handleVoted);
            };
            $pollAnswer.one('click', handlePollVote);
        }
    }

    $('.js-collection-poll').each(setUpCollectionPolls);
};
